import useStudentPedagogicalSheetRecords from '@/data/hook/assessment/useStudentPedagogicalSheetRecords';
import { useToggleReportRow } from '@/data/hook/scheduled-lesson-report/useToggleReportRow';
import Enrollment from '@/models/Enrollment';
import ScheduledLesson from '@/models/ScheduledLesson';
import { StudentAssessmentTypeEnum } from '@/models/StudentAssessment';
import { OccurrenceRecord } from '@/utils/assessments/klassPedagogicalSheetRecordTypes';

type UseStudentReportRowProps = {
  enrollment: Enrollment;
  scheduledLesson: ScheduledLesson;
};

export default function useStudentReportOcurrences({
  enrollment,
  scheduledLesson,
}: UseStudentReportRowProps) {
  const {
    records: occurrences,
    isLoading,
    error,
    invalidate,
  } = useStudentPedagogicalSheetRecords({
    studentId: enrollment.student.id,
    scheduledLessonId: scheduledLesson.id,
    types: [StudentAssessmentTypeEnum.OCCURRENCE],
  });

  const toggle = useToggleReportRow(!!occurrences.length);

  return {
    occurrences: occurrences as OccurrenceRecord[],
    isLoading,
    error,
    invalidate,
    toggle,
  };
}
